import { Avatar, Box } from '@mui/material'
import { heroTileSize } from './appConnectionCardConstants.js'

export function AppConnectionCardHeroAppAvatar({ safeTitle, iconUrl }) {
  const innerSize = heroTileSize - 8

  return (
    <Box
      sx={{
        width: heroTileSize,
        height: heroTileSize,
        borderRadius: 'var(--app-radius-xs)',
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        p: '3px',
        boxSizing: 'border-box',
      }}
    >
      {iconUrl ? (
        <Avatar
          src={iconUrl}
          alt={safeTitle}
          variant="rounded"
          imgProps={{ loading: 'lazy' }}
          sx={{ width: innerSize, height: innerSize, borderRadius: 'var(--app-radius-xs)' }}
        />
      ) : (
        <Avatar
          variant="rounded"
          sx={{
            width: innerSize,
            height: innerSize,
            borderRadius: 'var(--app-radius-xs)',
            bgcolor: 'background.default',
            color: 'text.primary',
            fontWeight: 700,
            fontSize: 'var(--app-font-size-sm)',
          }}
        >
          {safeTitle.slice(0, 1).toUpperCase()}
        </Avatar>
      )}
    </Box>
  )
}
